"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CurrencySymbolPosition;
(function (CurrencySymbolPosition) {
    CurrencySymbolPosition["START"] = "start";
    CurrencySymbolPosition["END"] = "end";
    CurrencySymbolPosition["DEFAULT"] = "default";
})(CurrencySymbolPosition || (CurrencySymbolPosition = {}));
exports.default = CurrencySymbolPosition;
